<template>
  <ConfirmDialog
    :model-value="dialog"
    title="Delete Confirmation"
    @cancel="close"
    @confirm="handleDelete"
  >
    <h4>Are you sure you want to delete {{ name }}?</h4>
  </ConfirmDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  props: {
    id: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    deleteAction: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      dialog: "delete/dialog",
    }),
  },
  methods: {
    ...mapActions({
      close: "delete/close",
      open: "delete/open",
      delete_user: "users/deleteUser",
    }),
    handleDelete() {
      if (this.deleteAction) {
        // If the provided callback function is defined, then use it, otherwise, delete user
        this.deleteAction()
      } else {
        this.delete_user(this.id);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
